<div class="card mb-5 tree-card">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4>{{ data?.title | capitalCase }}</h4>
    </div>
  </div>

  <div class="card-body tree-content" [style.height]="resolvedHeight">
    <!-- Loader -->
    <div *ngIf="loading && !hasError" class="loader-container">
      <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4" color="primary">
      </mat-progress-spinner>
    </div>

    <!-- Error state -->
    <app-data-error *ngIf="hasError" [message]="errorMessage"></app-data-error>

    <!-- Tree content -->
    <div *ngIf="!loading && !hasError" class="tree-body">
      <ng-container *ngFor="let node of treeData">
        <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: node, level: 0 }">
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!-- Recursive node template -->
<ng-template #renderNode let-node let-level="level">
  <div class="tree-node">

    <div class="node-row level-{{ level }}"
      (click)="handleNodeClick(node)"
      [class.clickable]="node.children?.length"
      [class.leaf]="!node.children?.length">

      <!-- Chevron -->
      <mat-icon class="arrow-icon" *ngIf="node.children?.length > 0"
        [class.rotated]="isExpanded(node)">
        chevron_right
      </mat-icon>
      <span class="arrow-spacer" *ngIf="!node.children?.length"></span>

      <!-- Node name -->
      <span class="node-name" [matTooltip]="node.name" matTooltipPosition="above"
        [style.font-weight]="level === 0 ? '600' : level === 1 ? '500' : '400'">
        {{ node.name }}
      </span>

      <!-- Score badge -->
      <span class="score-badge" [ngStyle]="getScoreColor(node.score)">
        {{ formatScore(node.score) }}
      </span>

    </div>

    <!-- Children — animated with *ngIf + @slide -->
    <div *ngIf="node.children?.length && isExpanded(node)" @slide class="node-children">
      <ng-container *ngFor="let child of node.children">
        <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child, level: level + 1 }">
        </ng-container>
      </ng-container>
    </div>

  </div>
</ng-template>
